/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileContactResponseType = typeof ProfileContactResponseType[keyof typeof ProfileContactResponseType];


export const ProfileContactResponseType = {
  email: 'email',
  phone: 'phone',
} as const;
